/*
 * @Author: liushuai 944566598@qq.com
 * @Date: 2023-12-13 14:50:33
 * @LastEditors: liushuai 944566598@qq.com
 * @LastEditTime: 2023-12-13 15:12:33
 * @FilePath: \esg-wenjuandiaocha\src\api\api-url\viewQuestion.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import {
	get,
	post,
	postForm
} from '../axios-req.js'
post
get
postForm
export const viewQuestionApi = {
	// 获取用户信息
	selectUserInfo: (data) => {
		return get('questionnaire/userInfoAdmin', data);
	},
	// 获取默认分类
	selectDefaultQuestion: (data) => {
		return get('questionnaire/defaultQuestionAdmin', data);
	},
	// 获取默认分类
	selectUserDefinedQuestion: (data) => {
		return get('questionnaire/userDefinedQuestionAdmin', data);
	},
}
